import $ from 'jquery';
import prestashop from 'prestashop';

prestashop.cart = prestashop.cart || {};

prestashop.cart.active_inputs = null;

const spinnerSelector = 'input[name="tso-product-quantity-spin"]';
let hasError = false;
let isUpdateOperation = false;
let errorMsg = '';

/**
 * Attach Bootstrap TouchSpin event handlers
 */
const createSpin = () => {
  $.each($(spinnerSelector), (index, spinner) => {
    $(spinner).TouchSpin({
      verticalbuttons: true,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-tso-touchspin js-tso-increase-product-quantity',
      buttonup_class: 'btn btn-touchspin js-tso-touchspin js-tso-decrease-product-quantity',
      min: parseInt($(spinner).attr('min'), 10),
      max: 1000000,
    });
  });

  $(prestashop.tsoSelectors.touchspin).off('touchstart.touchspin');

  CheckUpdateQuantityOperations.switchErrorStat();
}

$(document).ready(() => {
  const productLineInCartSelector = prestashop.tsoSelectors.cart.productLineQty;
  const promises = [];

  prestashop.on('updateCart', (event) => {

    if (typeof event.resp.cart !== "undefined") {
      prestashop.cart = event.resp.cart;
    }

    let requestData = {
      ajax: '1',
      method: 'refreshCart',
    };

    $.post(checkoutUrl, requestData)
      .then((resp) => {

        $(prestashop.tsoSelectors.cart.voucher).replaceWith(
          resp.cart_voucher,
        );
        $(prestashop.tsoSelectors.cart.overview).replaceWith(
          resp.cart_detailed,
        );
        $(prestashop.tsoSelectors.cart.detailedTotalsBottom).replaceWith(
          resp.cart_detailed_totals_bottom,
        );
        $(prestashop.tsoSelectors.cart.rightSummary).replaceWith(
          resp.cart_right_summary
        );

        $(prestashop.tsoSelectors.cart.productCustomizationId).val(0);

        $(prestashop.tsoSelectors.cart.lineProductQuantity).each(
          (index, input) => {
            const $input = $(input);
            $input.attr('value', $input.val());
          },
        );

        prestashop.emit('updatedCart', {eventType: 'updateCart', resp});
      })
      .fail((resp) => {
        prestashop.emit('handleError', {eventType: 'updateCart', resp});
      });
  });

  prestashop.on('updateCart', () => {
    $('.quickview').modal('hide');
  });

  prestashop.on('updatedCart', () => {
    createSpin();
  });

  createSpin();

  const $body = $('body');

  const isTouchSpin = (namespace) => namespace === 'on.startupspin' || namespace === 'on.startdownspin';

  const shouldIncreaseProductQuantity = (namespace) => namespace === 'on.startupspin';

  const findCartLineProductQuantityInput = ($target) => {
    const $input = $target.parents('.bootstrap-touchspin').find(productLineInCartSelector);
    if ($input.is(':focus')) {
      return null;
    }
    return $input;
  };

  /**
   * This function checks if any of the items in the cart have a URL containing a 'hash'.
   * If so, it means that the product is customizable by the "productfields" module.
   * In this case, it is necessary to reload the cart page to add the hash and make it work properly for further changes.
   */
  const hasAnyHashUrl = () => {
    const $elements = $(productLineInCartSelector);
    let found = false;
    $elements.each(function() {
      const $el = $(this);
      const downUrl = $el.data('down-url');
      const upUrl = $el.data('up-url');
      const updateUrl = $el.data('update-url');
      if ((typeof downUrl === 'string' && downUrl.includes('hash')) ||
          (typeof upUrl === 'string' && upUrl.includes('hash')) ||
          (typeof updateUrl === 'string' && updateUrl.includes('hash'))) {
        found = true;
        return false; // break
      }
    });
    return found;
  };

  const camelize = (subject) => {
    const actionTypeParts = subject.split('-');
    let camelizedSubject = '';
    for (let i = 0; i < actionTypeParts.length; i += 1) {
      let part = actionTypeParts[i];
      if (i !== 0) {
        part = part.substring(0, 1).toUpperCase() + part.substring(1);
      }
      camelizedSubject += part;
    }
    return camelizedSubject;
  };

  const parseCartAction = ($target, namespace) => {
    if (!isTouchSpin(namespace)) {
      return {
        url: $target.attr('href'),
        type: camelize($target.data('link-action')),
      };
    }
    const $input = findCartLineProductQuantityInput($target);
    if (!$input) {
      return false;
    }
    let cartAction = {};
    if (shouldIncreaseProductQuantity(namespace)) {
      cartAction = {
        url: $input.data('up-url'),
        type: 'increaseProductQuantity',
      };
    } else {
      cartAction = {
        url: $input.data('down-url'),
        type: 'decreaseProductQuantity',
      };
    }
    return cartAction;
  };

  const abortPreviousRequests = () => {
    let promise;
    while (promises.length > 0) {
      promise = promises.pop();
      promise.abort();
    }
  };

  const getTouchSpinInput = ($button) => $($button.parents('.bootstrap-touchspin').find('input'));

  const handleCartAction = (event) => {
    event.preventDefault();

    const $target = $(event.currentTarget);
    const {dataset} = event.currentTarget;
    const cartAction = parseCartAction($target, event.namespace);
    const requestData = {
      ajax: '1',
      action: 'update',
    };

    if (!cartAction) {
      return;
    }

    abortPreviousRequests();

    $('.cart-overview .loader').removeClass("off").addClass("on");

    $.ajax({
      url: cartAction.url,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend(jqXHR) {
        promises.push(jqXHR);
      },
    })
      .then((resp) => {

        // reload page if cartAction contains hash
        // This is for case product fields module
        if (hasAnyHashUrl()) {
          location.reload();
          return;
        }

        CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
        const $quantityInput = getTouchSpinInput($target);
        $quantityInput.val(resp.quantity);
        // Refresh cart preview
        prestashop.emit('updateCart', {
          reason: dataset,
          resp,
        });

        $('.cart-overview .loader').removeClass("on").addClass("off");
      })
      .fail((resp) => {
        prestashop.emit('handleError', {
          eventType: 'updateProductInCart',
          resp,
          cartAction: cartAction.type,
        });
      });
  };

  $body.on('click', '[data-link-action="tso-delete-from-cart"]', handleCartAction);
  $body.on('touchspin.on.startdownspin', spinnerSelector, handleCartAction);
  $body.on('touchspin.on.startupspin', spinnerSelector, handleCartAction);

  const sendUpdateQuantityInCartRequest = (updateQuantityInCartUrl, requestData, $target) => {
    abortPreviousRequests();
    $('.cart-overview .loader').removeClass("off").addClass("on");
    return $.ajax({
      url: updateQuantityInCartUrl,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend(jqXHR) {
        promises.push(jqXHR);
      },
    })
      .then((resp) => {
        if (hasAnyHashUrl()) {
          location.reload();
          return;
        }
        CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
        $target.val(resp.quantity);
        let dataset;
        if ($target && $target.dataset) {
          dataset = $target.dataset;
        } else {
          dataset = resp;
        }
        prestashop.emit('updateCart', {
          reason: dataset,
          resp,
        });
        $('.cart-overview .loader').removeClass("on").addClass("off");
      })
      .fail((resp) => {
        prestashop.emit('handleError', {
          eventType: 'updateProductQuantityInCart',
          resp,
        });
      });
  };

  const getRequestData = (quantity) => ({
    ajax: '1',
    qty: Math.abs(quantity),
    action: 'update',
    op: getQuantityChangeType(quantity),
  });

  const getQuantityChangeType = ($quantity) => $quantity > 0 ? 'up' : 'down';

  const updateProductQuantityInCart = (event) => {
    const $target = $(event.currentTarget);
    const updateQuantityInCartUrl = $target.data('update-url');
    const baseValue = $target.attr('value');
    const targetValue = $target.val();
    if (targetValue != parseInt(targetValue, 10) || targetValue < 0 || isNaN(targetValue)) {
      $target.val(baseValue);
      return;
    }
    const qty = targetValue - baseValue;
    if (qty === 0) {
      return;
    }
    $target.attr('value', targetValue);
    sendUpdateQuantityInCartRequest(updateQuantityInCartUrl, getRequestData(qty), $target);
  };

  $body.on('focusout keyup', productLineInCartSelector, (event) => {
    if (event.type === 'keyup') {
      if (event.keyCode === 13) {
        updateProductQuantityInCart(event);
      }
      return false;
    }

    updateProductQuantityInCart(event);

    return false;
  });

  $body.on('click', '.js-tso-discount .code', (event) => {
    event.stopPropagation();

    const $code = $(event.currentTarget);
    const $discountInput = $('[name=discount_name]');

    $discountInput.val($code.text());


    return false;
  });

  // cart accessory products
  if ($('#tso-cpa-bx-wrapper').length > 0) {
    var tsoCartProductAccessoriesBxSlider = $('#tso-cpa-bx-wrapper ul.bxslider-product-list').bxSlider();

    const tsoCPABxSliderInit = () => {
      var winSize = $(window).width(), sizeID;
      var pagerShow = false;
      var controlsShow = true;
      if (winSize < 1200 && winSize >= 768) {
        sizeID = 3;
      }
      else if (winSize < 768) {
        sizeID = 2;
        pagerShow = true;
        controlsShow = false;
      }
      else {
        sizeID = 5;
      }
      tsoCartProductAccessoriesBxSlider.reloadSlider({
        minSlides: sizeID,
        maxSlides: sizeID,
        slideWidth: 220,
        slideMargin: 25,
        nextText: '',
        prevText: '',
        infiniteLoop: true,
        // not working chrome link
        // autoHover: true,
        preventDefaultSwipeY: false,
        pager: pagerShow,
        controls: controlsShow,
        onSlideBefore: function() {
          $('#tso-cpa-bx-wrapper ul.bxslider-product-list img.b-lazy:visible').each(function() {
            var src = $( this ).attr("src");
            var data_src = $( this ).attr("data-src");
            if (src === undefined && data_src != '') {
              $( this ).attr("src", data_src);
            }
          });
        }
      });
    };

    $(window).on('resize load', function () {
      tsoCartProductAccessoriesBxSlider.stopAuto(true);
      tsoCPABxSliderInit();
    });
  }

  const handleVirtualProductDomainAction = (event) => {
    event.preventDefault();

    const $target = $(event.currentTarget);

    var id_product = parseInt($target.data('id-product'));
    var id_product_attribute = parseInt($target.data('id-product-attribute'));
    var position = parseInt($target.data('position'));
    var domain = $target.val();

    const requestData = {
      ajax: '1',
      method: 'updateVirtualProductDomain',
      id_product: id_product,
      id_product_attribute: id_product_attribute,
      position: position,
      domain: domain
    };

    if (id_product == 0) {
      return;
    }

    abortPreviousRequests();
    $.ajax({
      url: checkoutUrl,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend(jqXHR) {
        promises.push(jqXHR);
      },
    })
    .then((resp) => {
      CheckUpdateQuantityOperations.checkUpdateOpertation(resp);
      CheckUpdateQuantityOperations.switchErrorStat();
    });
  };
  $body.on('focusout', '.js-tso-virtual-product-domain', handleVirtualProductDomainAction);

});

const CheckUpdateQuantityOperations = {
  switchErrorStat: () => {
    /**
     * if errorMsg is not empty or if notifications are shown, we have error to display
     * if hasError is true, quantity was not updated : we don't disable checkout button
     */
    const $checkoutBtn = $('.cart_navigation a');

    if ( errorMsg !== '' && hasError) {
      $checkoutBtn.addClass('disabled');
    }

    if (errorMsg !== '') {
      // eslint-disable-next-line
      const strError = ` <article class="alert alert-danger" role="alert" data-alert="danger"><ul><li>${errorMsg}</li></ul></article>`;
      $('#notifications .container').html(strError);
      errorMsg = '';
      isUpdateOperation = false;
      if (!hasError) {
        // if hasError is true, quantity was not updated : allow checkout
        $checkoutBtn.removeClass('disabled');
      }
    } else if (!hasError && isUpdateOperation) {
      hasError = false;
      isUpdateOperation = false;
      $('#notifications .container').html('');
      $checkoutBtn.removeClass('disabled');
    }
  },
  checkUpdateOpertation: (resp) => {
    /**
     * resp.hasError can be not defined but resp.errors not empty: quantity is updated but order cannot be placed
     * when resp.hasError=true, quantity is not updated
     */
    // eslint-disable-next-line
    hasError = resp.hasOwnProperty('hasError') && resp.hasError;
    const errors = resp.errors || '';

    // 1.7.2.x returns errors as string, 1.7.3.x returns array
    if (errors instanceof Array) {
      errorMsg = errors.join(' ');
    } else {
      errorMsg = errors;
    }

    isUpdateOperation = true;
  },
};
